
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/hub",
      function () {
        return require("private-next-pages/sitemap/hub/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/hub"])
      });
    }
  